(function () {
    'use strict';

    var THEME = window.ErgoMouseTheme || {};
    var ROUTES = THEME.routes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js', checkout: '/checkout' };
    var CURRENCY = THEME.currency || 'ZAR';

    var SELECTORS = {
        addToCartButton: '#addToCartBtn',
        cartCloseButton: '#cartCloseBtn',
        cartDrawer: '#cartDrawer',
        cartOverlay: '#cartOverlay',
        cartQuantity: '#cartQuantity',
        cartDecreaseButton: '#cartDecreaseBtn',
        cartIncreaseButton: '#cartIncreaseBtn',
        cartStatus: '#cartStatus',
        cartSubtotal: '#cartSubtotal',
        cartTotal: '#cartTotal',
        cartUnitPrice: '#cartUnitPrice',
        checkoutButton: '#checkoutBtn',
        checkoutStatus: '#checkoutStatus',
        drawerCheckoutButton: '#drawerCheckoutBtn',
        faqItem: '.faq-item',
        faqQuestion: '.faq-question',
        floatingCartButton: '#floatingCartBtn',
        floatingCartCount: '#floatingCartCount',
        productForm: '#productForm',
        stickyBar: '#stickyBuy',
        stickyAddButton: '#stickyAddBtn',
        stickyCartButton: '#stickyCartBtn',
        stickyCartCount: '#stickyCartCount',
        buyBox: '#buyBox',
        reviewsSection: '#reviews-all',
        galleryMainImage: '#galleryMainImg',
        galleryLabel: '#galleryLabel',
        galleryLightbox: '#galleryLightbox',
        galleryLightboxClose: '#galleryLightboxClose',
        galleryLightboxImage: '#galleryLightboxImg',
        galleryLightboxLabel: '#galleryLightboxLabel',
        galleryThumb: '.gallery-thumb',
        galleryZoomButton: '#galleryZoomBtn',
        header: '#header',
        priceDisplay: '[data-price-display]',
        quantityDecreaseButton: '#quantityDecreaseBtn',
        quantityIncreaseButton: '#quantityIncreaseBtn',
        quantityValue: '#productQuantity'
    };

    var MAX_QUANTITY = 10;

    // Variant id + unit price (in cents) injected server-side into the product form.
    var form = document.querySelector(SELECTORS.productForm);
    var VARIANT_ID = form ? Number(form.getAttribute('data-variant-id')) : null;
    var unitPriceCents = form ? Number(form.getAttribute('data-unit-price')) : 79900;

    function formatMoney(cents) {
        return new Intl.NumberFormat('en-ZA', {
            style: 'currency',
            currency: CURRENCY,
            maximumFractionDigits: 0
        }).format((Number(cents) || 0) / 100);
    }

    function getSelectedQuantity() {
        var value = document.querySelector(SELECTORS.quantityValue);
        var quantity = parseInt(value ? value.textContent : '1', 10);
        return Math.min(Math.max(isFinite(quantity) ? quantity : 1, 1), MAX_QUANTITY);
    }

    function setSelectedQuantity(quantity) {
        var safe = Math.min(Math.max(quantity, 1), MAX_QUANTITY);
        var value = document.querySelector(SELECTORS.quantityValue);
        var dec = document.querySelector(SELECTORS.quantityDecreaseButton);
        var inc = document.querySelector(SELECTORS.quantityIncreaseButton);
        if (value) value.textContent = String(safe);
        if (dec) dec.disabled = safe <= 1;
        if (inc) inc.disabled = safe >= MAX_QUANTITY;
    }

    function setStatus(selector, message, type) {
        var el = document.querySelector(selector);
        if (!el) return;
        el.textContent = message;
        el.classList.toggle('error', type === 'error');
        el.classList.toggle('success', type === 'success');
    }

    function setCheckoutStatus(m, t) { setStatus(SELECTORS.checkoutStatus, m, t); }
    function setCartStatus(m, t) { setStatus(SELECTORS.cartStatus, m, t); }

    // ---- Shopify AJAX cart ----
    function fetchCart() {
        return fetch(ROUTES.cart, { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); });
    }

    function getLine(cart) {
        if (!cart || !cart.items) return null;
        for (var i = 0; i < cart.items.length; i++) {
            if (Number(cart.items[i].id) === VARIANT_ID) return cart.items[i];
        }
        return null;
    }

    function renderCart(cart) {
        var line = getLine(cart);
        var quantity = line ? line.quantity : 0;
        var unit = line ? line.final_price : unitPriceCents;
        var subtotal = cart ? cart.total_price : 0;

        var qEl = document.querySelector(SELECTORS.cartQuantity);
        var uEl = document.querySelector(SELECTORS.cartUnitPrice);
        var sEl = document.querySelector(SELECTORS.cartSubtotal);
        var tEl = document.querySelector(SELECTORS.cartTotal);
        var checkoutBtn = document.querySelector(SELECTORS.drawerCheckoutButton);
        var dec = document.querySelector(SELECTORS.cartDecreaseButton);
        var inc = document.querySelector(SELECTORS.cartIncreaseButton);
        var count = document.querySelector(SELECTORS.floatingCartCount);

        if (qEl) qEl.textContent = String(quantity);
        if (uEl) uEl.textContent = formatMoney(unit);
        if (sEl) sEl.textContent = formatMoney(subtotal);
        if (tEl) tEl.textContent = formatMoney(subtotal);
        if (checkoutBtn) checkoutBtn.disabled = quantity < 1;
        if (dec) dec.disabled = quantity < 1;
        if (inc) inc.disabled = quantity >= MAX_QUANTITY;
        var total = cart ? cart.item_count : 0;
        if (count) {
            count.textContent = String(total);
            count.hidden = total < 1;
        }

        var stickyCount = document.querySelector(SELECTORS.stickyCartCount);
        if (stickyCount) {
            stickyCount.textContent = String(total);
            stickyCount.hidden = total < 1;
        }
    }

    function refreshCart() {
        return fetchCart().then(renderCart).catch(function () {});
    }

    function addToCart(quantity) {
        if (!VARIANT_ID) {
            setCheckoutStatus('Product not connected yet. Select the ErgoMouse product in the theme editor.', 'error');
            return Promise.reject();
        }
        return fetch(ROUTES.cartAdd, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: quantity }] })
        }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
        });
    }

    function changeLine(quantity) {
        return fetch(ROUTES.cartChange, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: VARIANT_ID, quantity: quantity })
        }).then(function (r) { return r.json(); });
    }

    function goToCheckout() {
        window.location.assign(ROUTES.checkout || '/checkout');
    }

    // ---- Cart drawer open/close ----
    function openCart() {
        var d = document.querySelector(SELECTORS.cartDrawer);
        var o = document.querySelector(SELECTORS.cartOverlay);
        if (!d || !o) return;
        d.classList.add('open');
        o.classList.add('open');
        d.setAttribute('aria-hidden', 'false');
    }

    function closeCart() {
        var d = document.querySelector(SELECTORS.cartDrawer);
        var o = document.querySelector(SELECTORS.cartOverlay);
        if (!d || !o) return;
        d.classList.remove('open');
        o.classList.remove('open');
        d.setAttribute('aria-hidden', 'true');
    }

    function initCart() {
        var checkoutBtn = document.querySelector(SELECTORS.checkoutButton);
        var addBtn = document.querySelector(SELECTORS.addToCartButton);
        var drawerCheckoutBtn = document.querySelector(SELECTORS.drawerCheckoutButton);
        var floatingBtn = document.querySelector(SELECTORS.floatingCartButton);
        var cartDec = document.querySelector(SELECTORS.cartDecreaseButton);
        var cartInc = document.querySelector(SELECTORS.cartIncreaseButton);
        var closeBtn = document.querySelector(SELECTORS.cartCloseButton);
        var overlay = document.querySelector(SELECTORS.cartOverlay);
        var qDec = document.querySelector(SELECTORS.quantityDecreaseButton);
        var qInc = document.querySelector(SELECTORS.quantityIncreaseButton);

        if (qDec) qDec.addEventListener('click', function () { setSelectedQuantity(getSelectedQuantity() - 1); });
        if (qInc) qInc.addEventListener('click', function () { setSelectedQuantity(getSelectedQuantity() + 1); });

        if (checkoutBtn) {
            checkoutBtn.addEventListener('click', function () {
                setCheckoutStatus('', '');
                addToCart(getSelectedQuantity()).then(goToCheckout).catch(function () {
                    setCheckoutStatus('Could not start checkout. Please try again.', 'error');
                });
            });
        }

        if (addBtn) {
            addBtn.addEventListener('click', function () {
                addToCart(getSelectedQuantity()).then(function () {
                    setCartStatus('Cart updated.', 'success');
                    refreshCart();
                    openCart();
                }).catch(function () {
                    setCheckoutStatus('Could not add to cart. Please try again.', 'error');
                });
            });
        }

        if (drawerCheckoutBtn) drawerCheckoutBtn.addEventListener('click', goToCheckout);

        if (floatingBtn) {
            floatingBtn.addEventListener('click', function () {
                setCartStatus('', '');
                refreshCart();
                openCart();
            });
        }

        if (cartDec) {
            cartDec.addEventListener('click', function () {
                var q = document.querySelector(SELECTORS.cartQuantity);
                var current = q ? parseInt(q.textContent, 10) || 0 : 0;
                changeLine(Math.max(current - 1, 0)).then(renderCart);
                setCartStatus('Cart updated.', 'success');
            });
        }

        if (cartInc) {
            cartInc.addEventListener('click', function () {
                var q = document.querySelector(SELECTORS.cartQuantity);
                var current = q ? parseInt(q.textContent, 10) || 0 : 0;
                changeLine(Math.min(current + 1, MAX_QUANTITY)).then(renderCart);
                setCartStatus('Cart updated.', 'success');
            });
        }

        if (closeBtn) closeBtn.addEventListener('click', closeCart);
        if (overlay) overlay.addEventListener('click', closeCart);

        setSelectedQuantity(getSelectedQuantity());
        refreshCart();
    }

    // ---- Reviews section graceful empty-state ----
    // Judge.me renders nothing in the homepage review widget until reviews
    // exist. Hide the whole section until it has content, then reveal it
    // (covers async population after the app syncs / reviews are imported).
    function initReviewsVisibility() {
        var section = document.querySelector(SELECTORS.reviewsSection);
        var widget = section && section.querySelector('.jdgm-review-widget');
        if (!section || !widget) return;

        function hasContent() {
            if (widget.querySelector('.jdgm-rev, .jdgm-write-rev-link, .jdgm-histogram, .jdgm-all-reviews-rating')) return true;
            return widget.textContent.trim().length > 0;
        }

        function update() { section.hidden = !hasContent(); }

        section.hidden = true;
        update();

        if (typeof window.MutationObserver === 'function') {
            var obs = new MutationObserver(update);
            obs.observe(widget, { childList: true, subtree: true });
            setTimeout(function () { obs.disconnect(); }, 15000);
        }
    }

    // ---- Sticky mobile buy bar ----
    // Appears once the shopper has scrolled past the hero AND the buy box is
    // off screen, so there is always a way to purchase on a phone.
    function initStickyBar() {
        var bar = document.querySelector(SELECTORS.stickyBar);
        var addButton = document.querySelector(SELECTORS.stickyAddButton);
        var buyBox = document.querySelector(SELECTORS.buyBox);
        if (!bar) return;

        if (addButton) {
            addButton.addEventListener('click', function () {
                if (!VARIANT_ID) return;
                addButton.disabled = true;
                addToCart(getSelectedQuantity())
                    .then(function () {
                        setCartStatus('Cart updated.', 'success');
                        refreshCart();
                        openCart();
                        addButton.disabled = false;
                    })
                    .catch(function () {
                        addButton.disabled = false;
                    });
            });
        }

        var cartButton = document.querySelector(SELECTORS.stickyCartButton);
        if (cartButton) {
            cartButton.addEventListener('click', function () {
                setCartStatus('', '');
                refreshCart();
                openCart();
            });
        }

        var buyBoxVisible = false;

        function update() {
            var scrolledPastHero = window.scrollY > 240;
            bar.classList.toggle('visible', scrolledPastHero && !buyBoxVisible);
        }

        if (buyBox && typeof window.IntersectionObserver === 'function') {
            var observer = new IntersectionObserver(function (entries) {
                buyBoxVisible = entries[0].isIntersecting;
                update();
            }, { threshold: 0.12 });
            observer.observe(buyBox);
        }

        window.addEventListener('scroll', update, { passive: true });
        update();
    }

    // ---- UI behaviors (unchanged from original static site) ----
    function initHeader() {
        var header = document.querySelector(SELECTORS.header);
        if (!header) return;
        var update = function () { header.classList.toggle('scrolled', window.scrollY > 50); };
        update();
        window.addEventListener('scroll', update, { passive: true });
    }

    function initGallery() {
        var mainImage = document.querySelector(SELECTORS.galleryMainImage);
        var galleryLabel = document.querySelector(SELECTORS.galleryLabel);
        var zoomButton = document.querySelector(SELECTORS.galleryZoomButton);
        var thumbnails = Array.prototype.slice.call(document.querySelectorAll(SELECTORS.galleryThumb));
        if (!mainImage || !galleryLabel || thumbnails.length === 0) return;

        thumbnails.forEach(function (thumbnail) {
            thumbnail.addEventListener('click', function () {
                var src = thumbnail.dataset.gallerySrc;
                var label = thumbnail.dataset.galleryLabel;
                var image = thumbnail.querySelector('img');
                if (!src || !label) return;
                mainImage.src = src;
                mainImage.alt = image ? image.alt : label;
                galleryLabel.textContent = label;
                if (zoomButton) zoomButton.setAttribute('aria-label', 'Expand ' + label + ' image');
                thumbnails.forEach(function (item) { item.classList.remove('active'); });
                thumbnail.classList.add('active');
            });
        });
    }

    function initGalleryLightbox() {
        var zoomButton = document.querySelector(SELECTORS.galleryZoomButton);
        var mainImage = document.querySelector(SELECTORS.galleryMainImage);
        var galleryLabel = document.querySelector(SELECTORS.galleryLabel);
        var lightbox = document.querySelector(SELECTORS.galleryLightbox);
        var lightboxImage = document.querySelector(SELECTORS.galleryLightboxImage);
        var lightboxLabel = document.querySelector(SELECTORS.galleryLightboxLabel);
        var closeButton = document.querySelector(SELECTORS.galleryLightboxClose);
        if (!zoomButton || !mainImage || !galleryLabel || !lightbox || !lightboxImage || !lightboxLabel || !closeButton) return;

        var closeLightbox = function () {
            if (typeof lightbox.close === 'function') lightbox.close();
            else lightbox.removeAttribute('open');
        };

        zoomButton.addEventListener('click', function () {
            var label = galleryLabel.textContent || mainImage.alt || 'Selected product image';
            lightboxImage.src = mainImage.currentSrc || mainImage.src;
            lightboxImage.alt = mainImage.alt;
            lightboxLabel.textContent = label;
            if (typeof lightbox.showModal === 'function') lightbox.showModal();
            else lightbox.setAttribute('open', '');
            closeButton.focus();
        });

        closeButton.addEventListener('click', closeLightbox);
        lightbox.addEventListener('click', function (event) {
            if (event.target === lightbox) closeLightbox();
        });
    }

    function initFaq() {
        var faqItems = Array.prototype.slice.call(document.querySelectorAll(SELECTORS.faqItem));
        faqItems.forEach(function (item) {
            var question = item.querySelector(SELECTORS.faqQuestion);
            if (!question) return;
            question.addEventListener('click', function () {
                faqItems.forEach(function (other) { if (other !== item) other.classList.remove('active'); });
                item.classList.toggle('active');
            });
        });
    }

    function initSmoothScroll() {
        document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
            anchor.addEventListener('click', function (event) {
                var href = anchor.getAttribute('href');
                if (!href || href === '#') return;
                var target = document.getElementById(href.slice(1));
                if (!target) return;
                event.preventDefault();
                var offsetPosition = target.getBoundingClientRect().top + window.pageYOffset - 80;
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
            });
        });
    }

    function initImageFallbacks() {
        document.querySelectorAll('img').forEach(function (image) {
            image.addEventListener('error', function () {
                image.style.background = 'linear-gradient(135deg, #f3f4f6, #e5e7eb)';
                image.setAttribute('data-load-error', 'true');
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initHeader();
        initGallery();
        initGalleryLightbox();
        initFaq();
        initSmoothScroll();
        initImageFallbacks();
        initCart();
        initStickyBar();
        initReviewsVisibility();
    });
})();
